define(
    'Tavanoteam.TavanoTeam_Home_Extension.HomeSlider.View'
    , [
        'Utils',
        'SCView',
        'homeslider.tpl'
    ], function (
        Utils,
        SCViewModule,
        homeslider_tpl
    ) {

    'use strict';

    var SCView = SCViewModule.SCView;

    function TavanoTeamHomeExtensionSlider(options) {
        SCView.call(this, options);

        this.template = homeslider_tpl;

        /* Check images on slider */
        var imagesOnSlider = false;

        for (var i = 0; i < options.slides.length; i++) {
            if (options.slides[i].show && !!options.slides[i].imgSrcDesktop) {
                imagesOnSlider = true;
            }
        }

        /* Load BxSlider */
        var self = this;

        options.layout.on('afterShowContent', function () {
            if (imagesOnSlider) {
                /* Load slider with at last one image */
                var slider_loaded = false;

                self.$('img').on('load', function () {
                    if (!slider_loaded) {
                        slider_loaded = true;
                        loadSlider(self);
                    }
                });
            } else {

                /* Load slider without any images */
                loadSlider(self);
            }
        });

        var loadSlider = function (self) {
            var hasMoreThanOneSlider = (self.$('.tt-ext-home-slider-wrapper').children().length > 1);

            if (hasMoreThanOneSlider) {
                if (!self.$('.bx-wrapper').length) {
                    self.sliderContainer = self.$('.tt-ext-home-slider-wrapper').bxSliderNew({
                        auto: options.autoPlay,
                        pause: options.slideTime,
                        controls: options.arrows,
                        nextText: '<a class="tt-ext-home-slider-next"></a>',
                        prevText: '<a class="tt-ext-home-slider-prev"></a>',
                        pager: options.pager || options.customPager,
                        pagerCustom: options.customPager ? self.$('.tt-ext-home-slider-custom-pager') : false,
                        touchEnabled: true,
                        stopAutoOnClick: true,
                        onSliderLoad: function(currentIndex) {
                          /* Click Links issue fix (v2021.2 issue) */
                          self.$('.bx-viewport').removeClass('bx-viewport');
                        },
                    });
                } else {
                    if (self.sliderContainer) {
                        self.sliderContainer.redrawSlider();
                    }
                }
            }

            self.$('.tt-ext-home-slider').addClass('tt-ext-home-slider-loaded');
        }

        this.showCustomPager = options.customPager;

        /* Controls settings */
        this.sliderControlsClasses = options.controlsContainer ? 'tt-ext-home-slider-controlers-container ' : '';
        this.sliderControlsClasses += 'tt-ext-home-slider-controls-' + options.controlsColor.toLowerCase();
        this.sliderControlsClasses += options.controlsShadow ? ' tt-ext-home-slider-controls-shadow' : '';

        /* Reorder slides */
        if (options.slides.length > 0) {
            options.slides.sort(function (a, b) { return a.order - b.order; });
        }

        /* Height classes */
        this.sliderHeights = "";

        if (!imagesOnSlider) {
            this.sliderHeights += "tt-ext-home-slider-height-desktop-" + options.heights.desktop;
            this.sliderHeights += " tt-ext-home-slider-height-tablet-" + options.heights.tablet;
            this.sliderHeights += " tt-ext-home-slider-height-mobile-" + options.heights.mobile;
        }

        var configureHTMLContent = function (html) {
            if (!!html) {
                /* Translate */
                var translate_text = html.split("translate[[");

                if (translate_text.length > 1) {
                    translate_text.shift();

                    for (var i = 0; i < translate_text.length; i++) {
                        translate_text[i] = translate_text[i].split("]]")[0];
                        var value_origin = "translate[[" + translate_text[i] + "]]";
                        var value_translated = Utils.translate(translate_text[i]);
                        html = html.replace(value_origin, value_translated);
                    }
                }

                /* Remove whitespaces in the DOM.
                   It's not a common space (Red Dots - ""). Do NOT remove this line! */
                html = html.replace(/\5/g, "");
            }

            return html;
        }

        /* Create slides */
        var slides = [];
        var activeSlideIndex = 0;

        for (var i = 0; i < options.slides.length; i++) {
            if (options.slides[i].show) {
                activeSlideIndex++;

                /* Slide classes */
                var slideContentClasses = '';
                slideContentClasses += 'tt-ext-home-slider-slide-content-position-desktop-' + options.slides[i].positionDesktop.toLowerCase().replace('middle-', 'center-');
                slideContentClasses += ' tt-ext-home-slider-slide-content-position-mobile-' + options.slides[i].positionMobile.toLowerCase().replace('middle-', 'center-');
                slideContentClasses += ' text-color-' + options.slides[i].textColor.toLowerCase();
                slideContentClasses += ' text-shadow-' + options.slides[i].textShadow.toLowerCase();
                slideContentClasses += !!options.slides[i].additionalClass ? ' ' + options.slides[i].additionalClass : '';

                var desktopImage = !!options.slides[i].imgSrcDesktop ? options.slides[i].imgSrcDesktop : options.slides[i].imgSrcMobile;
                var mobileImage = (options.slides[i].imgSrcMobile === desktopImage) ? '' : options.slides[i].imgSrcMobile;

                var html = options.slides[i].content;
                html = configureHTMLContent(html);

                /* Remove link in HTML content if slide is a link itself */
                if (!!options.slides[i].link) {
                    var links_in_html = html.split("<a");

                    if (links_in_html.length > 1) {
                        links_in_html.shift();

                        for (var j = 0; j < links_in_html.length; j++) {
                            links_in_html[j] = links_in_html[j].split("</a>")[0];
                            var value_origin = "<a" + links_in_html[j] + "</a>";
                            html = html.replace(value_origin, "");
                        }
                    }

                    if (options.slides[i].touchpoint === "none") {
                        options.slides[i].touchpoint = false;
                    }
                }

                slides.push(
                    {
                        slideContainer: options.contentsContainer ? 'container' : '',
                        slideContentClasses: slideContentClasses,
                        imageURL: desktopImage,
                        imageMobileURL: mobileImage,
                        imageAlt: options.slides[i].imgAlt,
                        content: html,
                        link: options.slides[i].link,
                        touchpoint: options.slides[i].touchpoint,
                        background: !!options.slides[i].background ? "background:" + options.slides[i].background + ";" : "",
                        customPagerText: !!options.slides[i].customPagerText ? options.slides[i].customPagerText : 'slide 0' + activeSlideIndex
                    }
                );
            }
        }

        this.slides = slides;
    }

    TavanoTeamHomeExtensionSlider.prototype = Object.create(SCView.prototype);
    TavanoTeamHomeExtensionSlider.prototype.constructor = TavanoTeamHomeExtensionSlider;

    TavanoTeamHomeExtensionSlider.prototype.getContext = function () {
        return {
            sliderHeights: this.sliderHeights,
            sliderControlsClasses: this.sliderControlsClasses,
            showCustomPager: this.showCustomPager,
            slideshowList: this.slides
        }
    }

    return TavanoTeamHomeExtensionSlider;
});
